'use strict';

import React, {Component} from 'react';
import {observer} from "mobx-react";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import divWithClassName from "react-bootstrap/divWithClassName";

import planItemModalStore from './PlanItemModalStore';

import MoveCourseOnPlanForm from "@uw-it-sis/lib-react-myplan/lib/MoveCourseOnPlanForm";
import AddEditNoteForm from "@uw-it-sis/lib-react-myplan/lib/AddEditNoteForm";
import AddEditCourseOrPlaceholderForm from "@uw-it-sis/lib-react-myplan/lib/AddEditCourseOrPlaceholderForm";
import RemoveCourseFromPlanForm from "@uw-it-sis/lib-react-myplan/lib/RemoveCourseFromPlanForm";
import CourseSummaryWidget from "@uw-it-sis/lib-react-myplan/lib/CourseSummaryWidget";
import SectionSelector from "@uw-it-sis/lib-react-myplan/lib/SectionSelector";
import {isFalse} from "@uw-it-sis/lib-react/lib/Utils";
import {isCoursePlaceholder} from '@uw-it-sis/lib-react-myplan/lib/CourseUtils';
import {getGeneralPlaceholderName} from "@uw-it-sis/lib-react-myplan/lib/GeneralPlaceHolderConstants";
import PlaceholderSummaryWidget from '../common/PlaceholderSummaryWidget';
import TermUtils from "@uw-it-sis/lib-react/lib/TermUtils";
import appStore from "@uw-it-sis/lib-react/lib/AppStore";
import {PlanItemType} from "../lib/Constants";

class PlanItemModal extends Component {

    constructor(props) {
        super(props);
        this.props = props;
        this.store = planItemModalStore;

        this.onCloseModal = this.onCloseModal.bind(this);
    }

    componentDidMount() {
        this.store.mount();
    }

    onCloseModal() {
        this.store.closeModal();
    }

    render() {
        let data = this.store.getData();
        let actionType = this.store.getActionType();
        let isOpen = this.store.isOpen();
        let additionalAnalytics = this.store.getAdditionalAnalytics();

        let type = "";
        if (actionType === "accept") {
            type = PlanItemType.recommended;
        }

        let modalOverlay = null;
        if ( isOpen ) {

            let isSection = isFalse(data.hasOwnProperty("courseDetails"));

            let modalTitle;
            let actionTypeForm;
            let modalFooter;
            let modalCentered = true;
            let modalScrollable = false;

            let clusterName = null;
            if ( data.isClustered && isSection ) {
                clusterName = data.blockRegistration.type === "FIG" ? data.blockRegistration.type : "cluster";
            }

            switch ( actionType )  {
                case "accept":
                case "view":
                    let  dt = new Date();
                    let course = {
                        "id": data.courseDetails.courseId,
                        "subject": data.courseDetails.subjectArea,
                        "number": data.courseDetails.courseNumber,
                        "title": data.courseDetails.courseTitle,
                        "text": data.courseDetails.courseDescription,
                        "credit": data.courseDetails.credit,
                        "courseCode": `${data.courseDetails.subjectArea} ${data.courseDetails.courseNumber}`,
                        "type":`${actionType === "accept" ? PlanItemType.recommended : ""}` // Used by course summary widget to
                                                                                // determine whether to show the add to plan button
                    };
                    modalOverlay =
                        <CourseSummaryWidget
                            course={course}
                            analyticsContext={additionalAnalytics.context ?? 'PlanItem-Modal'}
                            planItemId={data.planItemDataObject.id}
                            openInPlanModal={true}
                            dt={dt.getTime()} />;
                    break;
                case "acceptPlaceholder":
                    modalTitle = `Add to ${TermUtils.makeTermDescriptionFromTermId(data.planItemDataObject.atp)}`;
                    actionTypeForm =
                        <PlaceholderSummaryWidget
                            item={data}
                            onCancel={this.onCloseModal}/>;
                    break;
                case "move":
                    modalTitle = "Move to Another Quarter";
                    actionTypeForm =
                        <MoveCourseOnPlanForm
                            planItemId={isSection ? data.planItemId : data.planItemDataObject.id}
                            termId={isSection ? data.atpId : data.planItemDataObject.atp}
                            onCancel={this.onCloseModal}
                            data={data}
                            isSection={isSection}
                            additionalAnalytics={additionalAnalytics} />;
                    break;
                case "delete":
                    modalTitle = `Delete ${appStore.isAdviser() ? 'recommendation for ' : ''}` + ( data.isClustered ? clusterName : ( isSection ? "section" + ( data.primary && data.hasPlannedSecondary ? "s" : "" ) : ( data.placeHolder ? "placeholder":"course") ) );
                    actionTypeForm =
                        <RemoveCourseFromPlanForm
                            planItemId={isSection ? data.planItemId : data.planItemDataObject.id}
                            termId={isSection ? data.atpId : data.planItemDataObject.atp}
                            onCancel={this.onCloseModal}
                            data={data}
                            isSection={isSection}
                            additionalAnalytics={additionalAnalytics} />;
                    break;
                case "updateNote":
                    let crCode = data.placeHolder ? `${getGeneralPlaceholderName(data.placeHolderCode, data.placeHolderValue)}` : `${data.courseDetails.subjectArea}  ${data.courseDetails.courseNumber}`
                    modalTitle = appStore.isAdviser()  ? `Add/Edit Description for ${crCode}` : `Add/Edit note for ${crCode}`;
                    actionTypeForm =
                        <AddEditNoteForm planItemId={data.planItemDataObject.id}
                                         courseCode={data.courseDetails.code} termId={data.planItemDataObject.atp}
                                         note={data.note}
                                         credit={data.courseDetails.credit}
                                         onCancel={this.onCloseModal}   />;
                    break;
                case "updatePlaceholder":
                    modalTitle = "Edit Placeholder/Note";
                    let formData = {
                        addToPlanSelector: isCoursePlaceholder(data.placeHolderCode) ? "course" : "placeholder",
                        courseCode: isCoursePlaceholder(data.placeHolderCode) ? data.placeHolderCode : `${data.planItemDataObject.refObjId}|${data.planItemDataObject.refObjType}`,
                        credit: data.credit,
                        isBackup: data.backup,
                        termId: data.planItemDataObject.atp,
                        note: data.note ? data.note : "",
                        placeHolderText: data.placeHolderCode === "Other" ? data.placeHolderValue : "",
                        planItemId: data.planItemDataObject.id
                    };
                    actionTypeForm =
                        <AddEditCourseOrPlaceholderForm context={"PlanView-addToPlan"}
                                                        termId={data.planItemDataObject.atp}
                                                        formData={formData}
                                                        onCancel={this.onCloseModal} />;
                    break;
                case "add":
                    modalTitle = appStore.isAdviser() ? "Recommend for " + data.qtrYear : "Add to " + data.qtrYear;
                    actionTypeForm =
                        <AddEditCourseOrPlaceholderForm context={"PlanView-addToPlan"}
                                                        termId={data.atpId}
                                                        onCancel={this.onCloseModal} />;
                    break;
                case "update":
                    let courseCode = data.courseDetails.code.replace(/\s\s+/g, ' ');
                    modalTitle = "Select sections for " + courseCode;
                    modalScrollable = true;
                    actionTypeForm = <SectionSelector courseCode={courseCode} courseId={data.courseDetails.courseId} termId={data.planItemDataObject.atp} additionalAnalytics={additionalAnalytics} />;
                    modalFooter =
                        <Modal.Footer className="d-grid">
                            <Button onClick={this.onCloseModal}>Done</Button>
                        </Modal.Footer>;
            }

            if (!modalOverlay) {
                modalOverlay =
                    <Modal id="modal-plan-item-action"
                           show={isOpen}
                           onHide={this.onCloseModal}
                           scrollable={modalScrollable}
                           centered={modalCentered}
                           aria-labelledby="modal-plan-item-action-title">
                        <Modal.Header closeButton>
                            <Modal.Title id="modal-plan-item-action-title"
                                         as={divWithClassName('h3')}>
                                {modalTitle}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {actionTypeForm}
                        </Modal.Body>
                        {modalFooter}
                    </Modal>;
            }

        }

        return modalOverlay;
    }
}

export default observer(PlanItemModal);